import React from 'react';
import Navigation from '../components/Navigation';
import SEO from '../components/SEO';

function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Terms of Service - FreeDisposableEmail.com | Usage Terms & Conditions"
        description="Read FreeDisposableEmail.com's terms of service. Understand the rules and guidelines for using our free temporary email service."
        keywords="terms of service, terms and conditions, usage terms, service agreement, user agreement"
      />
      <Navigation />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>Last updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Acceptance of Terms</h2>
              <p className="text-gray-700 mb-4">
                By accessing and using FreeDisposableEmail.com ("the Service"), you accept and agree to be bound 
                by the terms and provision of this agreement. If you do not agree to these terms, please do not 
                use our service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Description of Service</h2>
              <p className="text-gray-700 mb-4">
                FreeDisposableEmail.com provides temporary, disposable email addresses that automatically expire 
                after 30 minutes. The service is provided "as is" without warranties of any kind.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Acceptable Use</h2>
              <p className="text-gray-700 mb-4">You agree NOT to use the Service to:</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Send spam, phishing emails, or any malicious content</li>
                <li>Violate any laws or regulations</li>
                <li>Impersonate others or provide false information</li>
                <li>Interfere with or disrupt the Service</li>
                <li>Attempt to gain unauthorized access to any part of the Service</li>
                <li>Use the Service for any illegal or unauthorized purpose</li>
                <li>Transmit any viruses, malware, or harmful code</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Service Availability</h2>
              <p className="text-gray-700 mb-4">
                We strive to provide a reliable service but do not guarantee uninterrupted or error-free operation. 
                The Service may be temporarily unavailable due to maintenance, updates, or unforeseen circumstances.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Email Expiration</h2>
              <p className="text-gray-700 mb-4">
                All temporary email addresses and their associated emails automatically expire and are permanently 
                deleted after 30 minutes. We are not responsible for any emails or data lost after expiration.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 mb-4">
                FreeDisposableEmail.com shall not be liable for any indirect, incidental, special, consequential, 
                or punitive damages resulting from your use or inability to use the Service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">No Warranty</h2>
              <p className="text-gray-700 mb-4">
                The Service is provided "as is" and "as available" without any warranties, express or implied. 
                We do not guarantee that the Service will be secure, uninterrupted, or error-free.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Termination</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to terminate or suspend access to the Service immediately, without prior 
                notice, for any violation of these Terms of Service or for any other reason we deem necessary.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Changes to Terms</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to modify these Terms of Service at any time. Changes will be effective 
                immediately upon posting. Your continued use of the Service after changes are posted constitutes 
                acceptance of the modified terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Governing Law</h2>
              <p className="text-gray-700 mb-4">
                These Terms of Service shall be governed by and construed in accordance with applicable laws, 
                without regard to conflict of law provisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Information</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <p className="text-gray-700">
                <strong>Email:</strong> legal@freedisposableemail.com<br />
                <strong>Website:</strong> <a href="/contact" className="text-primary-600 hover:underline">Contact Page</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
